module.exports = __webpack_public_path__ + "static/media/us.eadfb4ed.svg";